// 
import WebComponent from '../webComponents/WebComponent';
import cookie from 'js-cookie';

/**
 * Komponenta nastaví do hlavního labelu hodnotu labelu aktuálně vybrané radio komponenty
 *
 */
export default class RadioSelectTab extends WebComponent {
	constructor(props) {
		super(props);
		this.setActiveRadioLabel = this.setActiveRadioLabel.bind(this);
		this.handleLabelClick = this.handleLabelClick.bind(this);
	};

	didMount() {
		const {
			targetSelector,
			labelSelector,
			radioSelector,
			activeClass,
		} = this.props;

		this.me = this.element.closest(targetSelector);
		this.label = this.me.querySelector(labelSelector);
		this.radios = this.me.querySelectorAll(radioSelector);
		this.activeClass = activeClass;

		Array.from(this.radios).forEach(target => {
			target.addEventListener('click', this.setActiveRadioLabel);
		});

		this.label.addEventListener('click', this.handleLabelClick);

		this.setActiveRadioLabel();
	};

	setActiveRadioLabel() {
		const {
		  cookieSave,
    } = this.props;

		let activeRadio = null,
        activeValue = null,
				activeLabel = null;

		Array.from(this.radios).forEach(target => {
			if (target.checked) {
				activeRadio = target.getAttribute('id');
				activeValue = target.value;
			}
		});

		if (activeRadio) {
			activeLabel = this.element.querySelector('label[for="' + activeRadio + '"]');

			this.label.innerHTML = (activeLabel.textContent || activeLabel.innerText);
		}

		if (cookieSave) {
      cookie.set(this.element.getAttribute('id'), activeValue, { expires: 7, path: '/' });
    }
    this.me.classList.remove(this.activeClass);
	};

	handleLabelClick() {
		this.me.classList.toggle(this.activeClass);
	};
}

RadioSelectTab.defaultProps = {
	labelSelector: '.control-label',
	radioSelector: 'input[type=radio]',
	activeClass: 'active',
  cookieSave: false,
};



// WEBPACK FOOTER //
// ./node_modules/fg-frontend/src/components/RadioSelectTab.js